import * as React from 'react';
import { Coffee, MapPin, Settings, LogOut } from 'lucide-react';

export type Props = {
  anchorEl: HTMLElement | null;
  onClose: () => void;
  onRecipes?: () => void;
  onSuggest?: () => void;
  onSettings?: () => void;
  onLogout?: () => void;
};

const BottomMoreMenu: React.FC<Props> = ({
  anchorEl,
  onClose,
  onRecipes,
  onSuggest,
  onSettings,
  onLogout,
}) => {
  const open = Boolean(anchorEl);
  const click = (fn?: () => void) => () => {
    onClose();
    fn?.();
  };

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[1400]" onClick={onClose}>
      <div className="absolute bottom-20 right-4 bg-card-bg rounded-lg shadow-xl min-w-[200px] py-2 border border-card-border" onClick={(e) => e.stopPropagation()}>
        <button onClick={click(onRecipes)} className="w-full flex items-center gap-3 px-4 py-3 hover:bg-hover-bg text-text-primary text-left">
          <Coffee className="w-5 h-5" />
          <span>Recipes</span>
        </button>
        <button onClick={click(onSuggest)} className="w-full flex items-center gap-3 px-4 py-3 hover:bg-hover-bg text-text-primary text-left">
          <MapPin className="w-5 h-5" />
          <span>Suggest a Place</span>
        </button>
        <button onClick={click(onSettings)} className="w-full flex items-center gap-3 px-4 py-3 hover:bg-hover-bg text-text-primary text-left">
          <Settings className="w-5 h-5" />
          <span>Settings</span>
        </button>
        <button onClick={click(onLogout)} className="w-full flex items-center gap-3 px-4 py-3 hover:bg-hover-bg text-text-primary text-left">
          <LogOut className="w-5 h-5" />
          <span>Logout</span>
        </button>
      </div>
    </div>
  );
};

export default BottomMoreMenu;
